// import React, { useState, useEffect } from "react";
// import { Modal, Button } from "react-bootstrap";
// import { FiX } from "react-icons/fi";
// import { useDispatch, useSelector } from "react-redux";
// import { updateProfile } from "../../../redux/slices/profileSlice";
// import { trackActivity } from "../../../redux/slices/trackActivitySlice";
// import { useScreenTime } from "../../../hooks/useScreen";

// const CertificateModal = ({ show, onHide }) => {
//   const dispatch = useDispatch();
//   const store = useSelector((state) => state.profile);

//   const [selectedCertifications, setSelectedCertifications] = useState([]);
//   const [error, setError] = useState("");


//   const certificationOptions = [
//     { id: "BLS", label: "BLS (Basic Life Support)" },
//     { id: "ACLS", label: "ACLS (Advanced Cardiac Life Support)" },
//     { id: "PALS", label: "PALS (Pediatric Advanced Life Support)" },
//     { id: "CCRN", label: "CCRN (Critical Care Registered Nurse)" },
//     { id: "NIH Stroke Scale", label: "NIH Stroke Scale" },
//   ];

//   useEffect(() => {
//   if (!show) return;

//   const certs = store?.profileItem?.data?.nurseProfile?.certifications;

//   if (!certs || certs.length === 0) {
//     setSelectedCertifications([]);
//     return;
//   }

//   const mapped = certificationOptions.filter((opt) =>
//     certs.includes(opt.id)
//   );

//   setSelectedCertifications(mapped);
// }, [show, store?.profileItem?.data?.nurseProfile?.certifications]);
//   const handleSelect = (cert) => {
//     const exists = selectedCertifications.some((c) => c.id === cert.id);

//     if (exists) {
//       setSelectedCertifications(
//         selectedCertifications.filter((c) => c.id !== cert.id),
//       );
//     } else {
//       setSelectedCertifications([...selectedCertifications, cert]);
//     }

//     setError("");
//   };

//   const handleSave = () => {
//     if (selectedCertifications.length === 0) {
//       setError("Please select at least one certification");
//       return;
//     }

//     const payload = {
//   name: store?.profileItem?.data?.full_name,
//   certifications: JSON.stringify(
//     selectedCertifications.map((cert) => cert.id)
//   ),
// };

//     dispatch(updateProfile(payload));
//   };

//   // Close modal after success
//   useEffect(() => {
//     if (store?.actionFlag === "PROFILE_UPDT_SCS") {
//       onHide();
//     }
//   }, [store?.actionFlag, onHide]);

  
// const { start, stop } = useScreenTime();

//   useEffect(() => {
//     if (!show) return;

//     // ✅ Modal opened
//     start();

//     return () => {
//       // ✅ Modal closed
//       const result = stop();


//       if (!result) return;

//       dispatch(
//         trackActivity({
//           page_name: "CHANGE_CERTIFICATIONS",
//           duration: result.durationMinutes,
//         })
//       );
//     };
//   }, [show]);
//   return (
//     <Modal
//       show={show}
//       onHide={onHide}
//       centered
//       size="lg"
//       dialogClassName="custom-modal profile-other-details-modal"
//     >
//       <Modal.Header>
//         <h5 className="modal-title">Certifications</h5>
//         <Button className="close-btn" onClick={onHide}>
//           <FiX size={24} />
//         </Button>
//       </Modal.Header>

//       <Modal.Body>
//         <div className="checkbox-options">
//           <div className="row">
//             {certificationOptions.map((cert) => (
//               <div
//                 key={cert.id}
//                 className={`checkbox-option col-lg-6 ${
//                   selectedCertifications.some((c) => c.id === cert.id)
//                     ? "selected"
//                     : ""
//                 }`}
//                 onClick={() => handleSelect(cert)}
//               >
//                 <div className="contentwrap">
//                   <input
//                     type="checkbox"
//                     checked={selectedCertifications.some(
//                       (c) => c.id === cert.id,
//                     )}
//                     readOnly
//                   />

//                   <label className="checkbox-label">{cert.label}</label>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>

//         {error && <div className="error-message mt-2">{error}</div>}

//         <div className="text-center mt-4">
//           <Button
//             className="btn-primary px-4"
//             onClick={handleSave}
//             disabled={store?.isLoading}
//           >
//             {store?.isLoading ? "Saving..." : "Save"}
//           </Button>
//         </div>
//       </Modal.Body>
//     </Modal>
//   );
// };

// export default CertificateModal;
import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import { FiX, FiUpload, FiEye } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import {
  getViewProfile,
  updateProfile,
  uploadCrtDocument,
} from "../../../redux/slices/profileSlice";
import { activityStart, activityEnd } from "../../../redux/slices/trackActivitySlice";

const CertificateModal = ({ show, onHide }) => {
  const dispatch = useDispatch();
  const store = useSelector((state) => state.profile);

  const [selectedCertifications, setSelectedCertifications] = useState([]);
  const [error, setError] = useState("");

  // store uploaded file urls
  const [files, setFiles] = useState({});

  const certificationOptions = [
    { id: "BLS", label: "BLS (Basic Life Support)" },
    { id: "ACLS", label: "ACLS (Advanced Cardiac Life Support)" },
    { id: "PALS", label: "PALS (Pediatric Advanced Life Support)" },
    { id: "CCRN", label: "CCRN (Critical Care Registered Nurse)" },
    { id: "NIH Stroke Scale", label: "NIH Stroke Scale" },
  ];

  useEffect(() => {
    if (!show) return;

    const certs = store?.profileItem?.data?.nurseProfile?.certifications;

    if (!certs || certs.length === 0) {
      setSelectedCertifications([]);
      return;
    }

    const mapped = certificationOptions.filter((opt) =>
      certs.includes(opt.id)
    );

    setSelectedCertifications(mapped);
  }, [show, store?.profileItem?.data?.nurseProfile?.certifications]);

  const handleSelect = (cert) => {
    const exists = selectedCertifications.some((c) => c.id === cert.id);

    if (exists) {
      setSelectedCertifications(
        selectedCertifications.filter((c) => c.id !== cert.id)
      );
    } else {
      setSelectedCertifications([...selectedCertifications, cert]);
    }

    setError("");
  };

  // const handleSave = () => {
  //   if (selectedCertifications.length === 0) {
  //     setError("Please select at least one certification");
  //     return;
  //   }

  //   const payload = {
  //     name: store?.profileItem?.data?.full_name,
  //     certifications: JSON.stringify(
  //       selectedCertifications.map((cert) => cert.id)
  //     ),
  //   };

  //   dispatch(updateProfile(payload));
  // };
  const handleSave = () => {
    if (selectedCertifications.length === 0) {
      setError("Please select at least one certification");
      return;
    }

    const payload = {
      name: store?.profileItem?.data?.full_name,
      certifications: JSON.stringify(
        selectedCertifications.map((cert) => cert.id)
      ),
    };

    setError("");

    dispatch(updateProfile(payload));
  };

  // upload certification document
  const handleFileUpload = (certId, file) => {
    if (!file) return;

    const allowedExtensions = ["pdf", "odt", "rtf", "doc", "docx", "jpg", "jpeg", "png", "gif", "bmp", "webp"];
    const fileExt = file.name
      .split(".")
      .pop()
      .toLowerCase();

    if (!allowedExtensions.includes(fileExt)) {
      setError("Only allowed file types: pdf, odt, rtf, doc, docx, jpg, jpeg, png, gif, bmp, webp");
      return;
    }

    setError("");

    const formData = new FormData();

    formData.append("file", file);
    formData.append("document_type", "certification");
    formData.append("document_name", certId);
    formData.append("description", certId + " certificate");

    dispatch(uploadCrtDocument(formData)).then(() => {
      dispatch(getViewProfile());
    });
  };
useEffect(() => {
  const docs = store?.profileItem?.data?.documents;

  if (!docs) return;

  const mapped = {};

  docs.forEach((doc) => {
    if (doc.document_type === "certification") {

     const fileUrl =
  `${process.env.REACT_APP_API_BASE_URL}/uploads/certification/${doc.file_path}`;

      mapped[doc.document_name] = {
        id: doc.id,
        url: fileUrl,
      };
    }
  });

  setFiles(mapped);
}, [store?.profileItem]);
  // Close modal after success
  useEffect(() => {
    if (store?.actionFlag === "PROFILE_UPDT_SCS") {
      onHide();
    }
  }, [store?.actionFlag, onHide]);


  useEffect(() => {
    if (!show) return;

    // Modal opened — start a tracking session
    dispatch(activityStart({ page_name: "CHANGE_CERTIFICATIONS", platform: "web" }));

    return () => {
      // Modal closed — end the session (duration recorded in seconds)
      dispatch(activityEnd({ page_name: "CHANGE_CERTIFICATIONS" }));
    };
  }, [show, dispatch]);

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      size="lg"
      dialogClassName="custom-modal profile-other-details-modal"
    >
      <Modal.Header>
        <h5 className="modal-title">Certifications</h5>
        <Button className="close-btn" onClick={onHide}>
          <FiX size={24} />
        </Button>
      </Modal.Header>

      <Modal.Body>
        <div className="checkbox-options">
          <div className="row">
            {certificationOptions.map((cert) => {
              const isSelected = selectedCertifications.some(
                (c) => c.id === cert.id
              );
              const uploadedFile = files[cert.id];

              return (
                <div
                  key={cert.id}
                  className={`checkbox-option col-lg-6 ${
                    isSelected ? "selected" : ""
                  }`}
                  onClick={() => handleSelect(cert)}
                >
                  <div className="contentwrap d-flex justify-content-between align-items-center">
                    <div>
                      <input
                        type="checkbox"
                        checked={isSelected}
                        readOnly
                      />

                      <label className="checkbox-label">
                        {cert.label}
                      </label>
                    </div>

                    {isSelected && (
                      <div
                        className="d-flex align-items-center gap-2"
                        onClick={(e) => e.stopPropagation()}
                      >
                        <label style={{ cursor: "pointer" }}>
                          <FiUpload size={18} />
                          <input
                            type="file"
                            hidden
                            onChange={(e) =>
                              handleFileUpload(
                                cert.id,
                                e.target.files[0]
                              )
                            }
                          />
                        </label>

                        {uploadedFile?.url && (
                          <a
                            href={uploadedFile.url}
                            target="_blank"
                            rel="noreferrer"
                          >
                            <FiEye size={18} />
                          </a>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        {error && <div className="error-message mt-2">{error}</div>}

        <div className="text-center mt-4">
          <Button
            className="btn-primary px-4"
            onClick={handleSave}
            disabled={store?.isLoading || selectedCertifications.length === 0}
          >
            {store?.isLoading ? "Saving..." : "Save"}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default CertificateModal;